import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AgencyUsersManagement from '../../components/platform/AgencyUsersManagement';

/**
 * Clients > Users — agency-scoped user management for staff portal and agency workspace.
 */
const ClientsUsersPage = ({ listSource = 'staff-portal', agencyName = '' }) => {
  const { agencyId: routeAgencyId } = useParams();
  const { user } = useAuth();
  const agencyId = routeAgencyId || user?.agency_id;

  if (!agencyId) {
    return (
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-amber-800">
        Agency context is required to view users.
      </div>
    );
  }

  return (
    <AgencyUsersManagement
      agencyId={agencyId}
      agencyName={agencyName}
      listSource={listSource}
      pageTitle="Users"
    />
  );
};

export default ClientsUsersPage;
